export const COMMENT_MAX_LENGTH = 255;
export const CONTENT_MAX_LENGTH = 100;
export const BANK_BIK_MAX_LENGTH = 9;
export const BANK_SETTLEMENT_ACCOUNT_MAX_LENGTH = 20;
export const BANK_CORRESPONDENT_ACCOUNT_MAX_LENGTH = 20;

export const FILE_NAME_MAX_LENGTH = 50;
